<footer class="m-footer">
  <span>{{ environment.version }} &copy; {{ year }} Sarraf</span>
  <span class="m-footer__credit">
    Design &amp; Develop by <a href="https://znosoft.net/" target="_blank" rel="noopener">ZNOSoft</a>
  </span>
</footer>
